import {
  HEX,
  Targeting
} from "../../../src";
import { SEC } from "../../../src";
import { curse_atk_condition } from "../../conditions/curse-weakness";
const curse_atk = {
  slug: "curse_atk",
  name: "Curse of Weakness",
  abilityIcon: "curse_atk",
  description: "Wraps a foe in shadow, sapping their strength",
  costs: [{ stat: "mana", value: 18 }],
  targeting: Targeting.MissileMid,
  cooldown: SEC(6),
  projectileSpeed: 6,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          addConditions: [
            {
              slug: "curse_atk",
              name: "Weakness",
              tags: ["debuff", "curse"]
            }
          ],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "black"]
};
export {
  curse_atk,
  curse_atk_condition
};
//# sourceMappingURL=data:application/json;base64,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
